import { FunctionComponent, useEffect, useState } from "react"
import styles from "./subNavigation.module.scss"
import { faSidebar } from "@fortawesome/pro-solid-svg-icons"
import Button from "../../shared/button"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { WellIdentificationFieldsFragment } from "../../../generated/graphql"
import WellConfigurationMenu from "./WellConfigurationMenu"
import IwpSubPageNavigation from "./IwpSubPageNavigation"
import { SingleValue } from "react-select"
import { useLocation, useNavigate } from "react-router-dom"
import ReactSingleSelect, {
    ReactSingleSelectOptionT,
} from "../../shared/input/react-select/singleSelect"
import WellFavoriteToggle from "../../shared/wellFavoriteIcon"

export type SubNavDropDownI = {
    configurationMenu: boolean
    subPageMenu: boolean
}

interface IwpSubNavigationPropsI {
    wellIdentificationfragment: WellIdentificationFieldsFragment | undefined
    availableWells: ReactSingleSelectOptionT[]
    toogleStatusBar: () => void
    windowWidth: number
    availableWellsLoading: boolean
}

const IwpSubNavigation: FunctionComponent<IwpSubNavigationPropsI> = ({
    wellIdentificationfragment,
    toogleStatusBar,
    windowWidth,
    availableWells,
    availableWellsLoading,
}) => {
    // hooks
    const navigate = useNavigate()
    const location = useLocation()

    // state
    const [dropDownMenus, setDropDownMenus] = useState<SubNavDropDownI>({
        configurationMenu: false,
        subPageMenu: false,
    })

    // constants
    const mobileBreakPoint = 768
    const selectedWell: ReactSingleSelectOptionT = {
        value: wellIdentificationfragment?.id as string,
        label: wellIdentificationfragment?.name as string,
        disabled: false,
    }

    // handlers
    const handleWellSelectorUpdate = (
        e: SingleValue<ReactSingleSelectOptionT>
    ) => {
        const wellId = e?.value
        if (!wellId) {
            console.error("Well ID is undefined. Cannot navigate to well page.")
            return
        }

        // NOTE: this is a fragile piece of code and relies on the structure of the iwp urls to maintain a consistent format of:
        // /baseSlug/:wellId
        // If that format is changed or a new sub route with a different format is added, this piece of code will not work and redirect users back to the dashboard as an unmatched routes.
        const baseSlug = location.pathname.split("/")[1]
        const absoluteUpdatedRoute = `/${baseSlug}/${wellId}`
        navigate(absoluteUpdatedRoute)
    }

    // effects
    useEffect(() => {
        const closeConfigurationMenu = () => {
            setDropDownMenus({
                configurationMenu: false,
                subPageMenu: false,
            })
        }

        document.addEventListener("click", closeConfigurationMenu)

        return () => {
            document.removeEventListener("click", closeConfigurationMenu)
        }
    }, [])

    return (
        <div className={styles.subnavigation}>
            <div className={styles.subnavigationLeft}>
                <div className={styles.sideBarIcon}>
                    <Button
                        handleButtonClick={toogleStatusBar}
                        status="secondary"
                    >
                        <FontAwesomeIcon
                            style={{ width: "24px", height: "24px" }}
                            icon={faSidebar}
                        />
                    </Button>
                </div>
                <div className={styles.subnavigationLeftText}>
                    <ReactSingleSelect
                        options={availableWells}
                        onChange={handleWellSelectorUpdate}
                        value={selectedWell}
                        isSearchable={true}
                        isClearable={false}
                        width="100%"
                        isLoading={availableWellsLoading}
                    />
                </div>
                <div className={styles.favoriteToggle}>
                    <WellFavoriteToggle
                        isFavorite={wellIdentificationfragment?.isFavorite}
                        wellID={wellIdentificationfragment?.id}
                        wellName={wellIdentificationfragment?.name}
                        loading={availableWellsLoading}
                    />
                </div>
            </div>
            <div className={styles.subnavigationRight}>
                <div className={styles.wellConfigMenu}>
                    {wellIdentificationfragment && (
                        <WellConfigurationMenu
                            dropDownMenus={dropDownMenus}
                            setDropDownMenus={setDropDownMenus}
                            wellIdentificationfragment={
                                wellIdentificationfragment
                            }
                            windowWidth={windowWidth}
                            mobileBreakPoint={mobileBreakPoint}
                        />
                    )}
                </div>
                {wellIdentificationfragment && (
                    <IwpSubPageNavigation
                        dropDownMenus={dropDownMenus}
                        setDropDownMenus={setDropDownMenus}
                        wellIdentificationfragment={wellIdentificationfragment}
                        windowWidth={windowWidth}
                        mobileBreakPoint={mobileBreakPoint}
                    />
                )}
            </div>
        </div>
    )
}

export default IwpSubNavigation
